/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataService_Domain_Models_ErrorCodes {
    NONE = 'NONE',
    INTERNAL_ERROR = 'INTERNAL_ERROR',
    INVALID_INPUT = 'INVALID_INPUT',
    STUDY_NOT_AVAILABLE = 'STUDY_NOT_AVAILABLE',
    INVALID_PANELIST_STATUS = 'INVALID_PANELIST_STATUS',
    PANELIST_ALREADY_SURVEY_COMPLETED = 'PANELIST_ALREADY_SURVEY_COMPLETED',
    SQB_RULE_FAILED = 'SQB_RULE_FAILED',
    STUDY_QUOTA_IS_FULL = 'STUDY_QUOTA_IS_FULL',
    USER_LOGIN_FAILED = 'USER_LOGIN_FAILED',
    USER_MAX_LOGIN_ATTEMPT_REACHED = 'USER_MAX_LOGIN_ATTEMPT_REACHED',
    LOCK_TIMEOUT = 'LOCK_TIMEOUT',
    CALENDAR_INTEGRATION_ERROR = 'CALENDAR_INTEGRATION_ERROR',
    SESSION_IS_FULL = 'SESSION_IS_FULL',
    NO_TECHNICIAN_AVAILABLE = 'NO_TECHNICIAN_AVAILABLE',
    RUN_PROCEDURE_ERROR = 'RUN_PROCEDURE_ERROR',
    SCRIPT_COMMAND_ERROR = 'SCRIPT_COMMAND_ERROR',
    WORKFLOW_COMMAND_ERROR = 'WORKFLOW_COMMAND_ERROR',
    INVALID_PANELIST_PSGUID = 'INVALID_PANELIST_PSGUID',
    INVALID_STUDY_UID = 'INVALID_STUDY_UID',
    INVALID_DATALINK_KEYID = 'INVALID_DATALINK_KEYID',
    SURVEY_ENGINE_LEGACY_MODE_ON = 'SURVEY_ENGINE_LEGACY_MODE_ON',
    SURVEY_INITILIZATION_ERROR = 'SURVEY_INITILIZATION_ERROR',
    EXTERNAL_STATUS_UPDATE_ERROR = 'EXTERNAL_STATUS_UPDATE_ERROR',
    POST_SURVEY_SID_ACTIVE = 'POST_SURVEY_SID_ACTIVE',
    POST_SURVEY_INVALID_CURRENT_SCHEDULE = 'POST_SURVEY_INVALID_CURRENT_SCHEDULE',
    POST_SURVEY_SESSION_CONFIRM_ERROR = 'POST_SURVEY_SESSION_CONFIRM_ERROR',
    POST_SURVEY_SESSION_CANCEL_ERROR = 'POST_SURVEY_SESSION_CANCEL_ERROR',
    POST_SURVEY_SESSIONS_RESCHEDULE_ERROR = 'POST_SURVEY_SESSIONS_RESCHEDULE_ERROR',
    POST_SURVEY_SESSIONS_SCHEDULE_ERROR = 'POST_SURVEY_SESSIONS_SCHEDULE_ERROR',
    POST_SURVEY_STUDY_QUOTA_IS_FULL = 'POST_SURVEY_STUDY_QUOTA_IS_FULL',
    POST_SURVEY_DYNAMIC_QUOTA_ASSIGNMENT_FAILED = 'POST_SURVEY_DYNAMIC_QUOTA_ASSIGNMENT_FAILED',
    POST_SURVEY_NO_SESSIONS_AVAILABLE = 'POST_SURVEY_NO_SESSIONS_AVAILABLE',
    POST_SURVEY_GATE_ASSIGNMENT_FAILED = 'POST_SURVEY_GATE_ASSIGNMENT_FAILED',
    AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE',
    AUTHORIZATION_FAILURE = 'AUTHORIZATION_FAILURE',
}
